/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.14",
    versionName: "0.2.0-nightly.2025.11.14",
    versionChannel: "nightly",
    buildDate: "2025-11-14T00:08:05.279Z",
    commitHash: "56d0a2004fe29d95132b52f11308054de2995c75",
};
